export default __webpack_public_path__ + "static/media/servipay.774567fb.png";